<script>
  export let badge;
</script>

<div class="flex items-center justify-start">
  <div class="flex-shrink-0 bg-center bg-no-repeat bg-contain nx-badge" style="background-image: url({badge.urls.image})" />
  <div class="flex flex-col items-start justify-start ml-4">
    <div class="text-lg font-medium text-brand-gray">{badge.name}</div>
    <div class="text-14 leading-tight mt-1 font-normal text-brand-gray-70">{badge.description}</div>
  </div>
</div>

<style>
  .nx-badge {
    width: 78px;
    height: 87px;
  }
</style>
